import styled from 'styled-components';

export const LayoutWrapper = styled.div`
  font-weight: 400;
`;
